import { CreativeTypes } from '@bynder-studio/render-core';
import ProxyServerConnector from '../web/src/services/connectors/ProxyServerConnector';

export interface ComponentCollection {
    id: number;
    name: string;
}

interface GetComponentCollectionsParams {
    size: number;
    page: number;
    presetSearch?: string;
    collectionSearch?: string;
    sort?: [string, string];
    types?: CreativeTypes[];
}

export interface GetComponentCollectionsResponse {
    content: ComponentCollection[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            empty: boolean;
            sorted: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalElements: number;
    totalPages: number;
    first: boolean;
    size: number;
    number: number;
    sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    empty: boolean;
}

interface AddComponentCollectionRequest {
    name: string;
}

class ComponentCollectionService extends ProxyServerConnector {
    gateway: ProxyServerConnector;

    constructor(path = '/presets-collections') {
        super(path);
        this.gateway = new ProxyServerConnector(path, GATEWAY_PREFIX);
    }

    getComponentCollections({
        size,
        page,
        collectionSearch,
        presetSearch,
        sort,
        types,
    }: GetComponentCollectionsParams) {
        const params = new URLSearchParams({
            size: size.toString(),
            page: page.toString(),
        });

        if (collectionSearch) {
            params.append('collectionSearch', collectionSearch);
        }

        if (presetSearch) {
            params.append('presetSearch', presetSearch);
        }

        if (sort?.length) {
            params.append('sort', sort.join(','));
        }

        if (types?.length) {
            params.append('types', types.join(','));
        }

        return this.gateway.get<GetComponentCollectionsResponse>(`?${params.toString()}`);
    }

    addComponentCollection(data: AddComponentCollectionRequest) {
        return this.gateway.post<ComponentCollection>('', data);
    }
}

export default new ComponentCollectionService();
